import { ENV_VARS } from '@/env';
import type { BaseOidcConfig, OidcSettings } from '@nvision/oidc';
import { OIDC_AUTH_ROUTES } from './routes';

export const oidcConfigServices: BaseOidcConfig = {
  authority: ENV_VARS.REACT_APP_OIDC_AUTHORITY ?? '',
  clientId: ENV_VARS.REACT_APP_OIDC_CLIENT_ID ?? '',
} as const;

export const oidcConfig: OidcSettings = {
  authority: ENV_VARS.REACT_APP_OIDC_AUTHORITY ?? '',
  client_id: ENV_VARS.REACT_APP_OIDC_CLIENT_ID ?? '',
  redirect_uri: `${window.location.origin}${OIDC_AUTH_ROUTES.OIDC_AUTH_CALLBACK}`,
  silent_redirect_uri: `${window.location.origin}${OIDC_AUTH_ROUTES.OIDC_AUTH_CALLBACK}`,
  // post_logout_redirect_uri: `${window.location.origin}/auth/logout-callback`,
  loadUserInfo: true,
  automaticSilentRenew: false,
  scope: 'openid profile tms-svc/*:cruds',
} as const;
